import React from 'react'
import Image from '../../../common/footer/Images/Image'

function EBookWidgetStencil({ classes }) {
  return (
    <div>
      <div className={`edu-blog-widget widget-instagram ${classes ? classes : ''}`}>
        <div className="inner">

          <div class="d-flex justify-content-between py-3 border-bottom-1">
            <div className="price fs-17 mb--10 w-50 placeholder placeholder-glow "></div>
            <div className="price w-25 h-100 placeholder placeholder-glow"></div>
          </div>

          <div className="content mt--20">
            <div className="instagram-list">
              {[0, 1, 2, 3, 4, 5].map((elm) => (
                <>
                  <a>
                    <Image src="#" alt="Thumbnail" fill />
                  </a>
                </>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default EBookWidgetStencil
